export default "__VITE_ASSET__DsKbKHL5__"